const sign = require('jwt-encode');

export const encodeToJWTToken = (payload: Record<string, any>): Promise<string> => {
	const secret = process.env.REACT_APP_JWT_SECRET || 'MESC_DCAFE_KEY';

	return sign(payload, secret);
};
